import { Container } from '@/ui/components/Container/Container';
import styles from './EventSummary.module.scss';

interface EventSummaryTitleProps {
  title: string;
}

export const EventSummaryTitle = ({
  title,
}: EventSummaryTitleProps) => {
  return (
      <h2 className={styles.eventSummaryTitle}>{title}</h2>
  );
};
